module.exports = {
  loginTitle: 'CRO System',
  loginBtn: 'Sign-in',
  logout: 'Logout',
  logoTip: 'Do you want to log out?',
  oktaError: 'You are not authorized, pls contact the administration'
}
